/*! Copyright (c) Safe As Milk. All rights reserved. */
import { debounce } from "utils";

class ProductSingle extends HTMLElement {
    #resizeObserver;
    #variant;
    #descriptionPlacement;
    #descriptionMediaQuery;
    #descriptionChangeListener;
    constructor() {
        super();
        this.updateGallery = this.updateGallery.bind(this);
        this.setPdpHeight = this.setPdpHeight.bind(this);
    }
    connectedCallback() {
        this.mediaGallery = this.querySelector("media-gallery");
        this.productUrl = this.dataset.productUrl;
        this.sectionId = this.dataset.sectionId;
        this.#moveModalsFromStickyScrollContainer();
        this.#resizeObserver = new ResizeObserver(debounce(this.setPdpHeight, 5));
        this.#resizeObserver.observe(this.querySelector(".product-single__box"));
        this.#setupResponsiveDescription();
    }
    disconnectedCallback() {
        this.#resizeObserver.disconnect();
        this.#descriptionMediaQuery?.removeEventListener("change", this.#descriptionChangeListener);
    }
    // HLC: one description node, with independent desktop and mobile positions.
    #setupResponsiveDescription() {
        this.#descriptionMediaQuery?.removeEventListener("change", this.#descriptionChangeListener);
        const mobileAnchor = this.querySelector("[data-hlc-description-mobile-anchor]");
        const desktopAnchor = this.querySelector("[data-hlc-description-desktop-anchor]");
        if (!mobileAnchor || !desktopAnchor) return;
        let node = this.#descriptionPlacement?.node;
        if (!node || !this.contains(node) || this.#descriptionPlacement.mobileAnchor !== mobileAnchor || this.#descriptionPlacement.desktopAnchor !== desktopAnchor) {
            node = desktopAnchor.nextElementSibling;
        }
        if (!node?.matches(".product-single__box__block--description")) return;
        this.#descriptionPlacement = { mobileAnchor, desktopAnchor, node };
        // Match the single-column breakpoint in component-product.css.
        this.#descriptionMediaQuery = window.matchMedia("(max-width: 61.24em)");
        this.#descriptionChangeListener = () => {
            const anchor = this.#descriptionMediaQuery.matches ? mobileAnchor : desktopAnchor;
            if (anchor.nextElementSibling !== node) anchor.after(node);
            this.setPdpHeight();
        };
        this.#descriptionMediaQuery.addEventListener("change", this.#descriptionChangeListener);
        this.#descriptionChangeListener();
    }
    setPdpHeight() {
        this.style.setProperty("--pdp-height", `${this.querySelector(".product-single__box").offsetHeight}px`);
    }
    updateGallery(mediaGallery) {
        const gallery = this.querySelector("media-gallery");
        if (!mediaGallery || !this.sectionId || !this.productUrl || !gallery) return;
        const newGallery = mediaGallery;
        gallery.replaceWith(newGallery);
        this.mediaGallery = newGallery;
        if (window.ShopifyXR) window.ShopifyXR.setupXRElements();
    }
    updateMedia() {
        if (!this.mediaGallery || !this.#variant.featured_media) return;
        const mediaId = this.#variant.featured_media.id;
        this.mediaGallery.goToSlide(mediaId);
    }
    set variant(variant) {
        this.#variant = variant;
        this.updateMedia();
    }
    get variant() {
        return this.#variant;
    }
    #moveModalsFromStickyScrollContainer() {
        const modals = this.querySelectorAll("sticky-scroll modal-dialog, sticky-scroll popup-dialog");
        modals.forEach((modal => {
            this.append(modal);
        }));
    }
}

customElements.define("product-single", ProductSingle);
//# sourceMappingURL=product-single.js.map
